import Container from '@/components/Container';
import SubContainer from '@/components/Container/SubContainer';

export const CalendarSkeleton = () => {
  const monthTabs = (
    <div className="mt-4 flex w-full gap-4 overflow-x-auto pb-4">
      {Array.from({ length: 12 }).map((_, index) => (
        <div key={index} className="h-10 w-24 animate-pulse rounded-lg bg-gray-300" />
      ))}
    </div>
  );

  const eventCards = (
    <div className="mt-8 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
      {Array.from({ length: 8 }).map((_, index) => (
        <div
          key={index}
          className="flex h-[200px] flex-col gap-4 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
          <div className="h-6 w-24 animate-pulse rounded-md bg-gray-300" />
          <div className="h-8 w-full animate-pulse rounded-md bg-gray-300" />
          <div className="h-6 w-3/4 animate-pulse rounded-md bg-gray-300" />
          <div className="mt-auto h-8 w-full animate-pulse rounded-md bg-gray-300" />
        </div>
      ))}
    </div>
  );

  return (
    <Container className="mt-sh-60 !gap-y-0">
      <SubContainer className="gap-4 lg:col-start-11 lg:col-end-3">
        <div className="space-y-4">
          <div className="h-8 w-3/4 animate-pulse rounded-md bg-gray-300" />
          <div className="h-6 w-1/2 animate-pulse rounded-md bg-gray-300" />
        </div>
        <div className="my-4 h-2 w-full animate-pulse rounded-lg bg-gray-300" />
        <div className="mt-4 h-10 w-32 animate-pulse rounded-lg bg-gray-300" />
        <div className="my-4 h-2 w-full animate-pulse rounded-lg bg-gray-300" />
        {monthTabs}
        <div className="my-4 h-2 w-full animate-pulse rounded-lg bg-gray-300" />
        <div className="mx-auto flex w-full justify-center">
          <div className="mt-4 h-10 w-32 animate-pulse rounded-lg bg-gray-300" />
        </div>
        {eventCards}
      </SubContainer>
    </Container>
  );
};
